import { LessonsCarouselParams } from '@yandex-int/k-common/typings/api/models/main-page';
import { ArrowShort } from 'education-icons';
import { H2, ShowcaseLessonCard, Carousel, Button, Link } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';

import { b } from '../cn';

const DEFAULT_SCROLL_STEP = (184 + 24) * 3;

export const LessonsCarouselsCarousel = ({ title, items, titleLink }: LessonsCarouselParams) => {
    return (
        <div className={b('carousel-wrapper')}>
            <Link className={b('carousel-title')} disabled={!titleLink} to={titleLink}>
                <H2 typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}>{title}</H2>
                {titleLink && <ArrowShort className={b('carousel-title-icon')} />}
            </Link>
            <Carousel
                allowLinearScroll={true}
                mix={b('carousel')}
                scrollStep={DEFAULT_SCROLL_STEP}
                transitionTimeMs={300}
            >
                <Carousel.Controls>
                    <Carousel.Prev mix={b('carousel-prev')}>
                        <Button
                            icon={<ArrowShort className={b('carousel-prev-icon')} />}
                            rounded={true}
                            size={Button.SIZE.L}
                            view={Button.VIEW.RAISED}
                        />
                    </Carousel.Prev>
                    <Carousel.Next mix={b('carousel-next')}>
                        <Button
                            icon={<ArrowShort className={b('carousel-next-icon')} />}
                            rounded={true}
                            size={Button.SIZE.L}
                            view={Button.VIEW.RAISED}
                        />
                    </Carousel.Next>
                </Carousel.Controls>
                <Carousel.Content mix={b('carousel-content')}>
                    {items.map(({ assignedCount, badgeNumber, description, image, id, rating, subject }) => (
                        <ShowcaseLessonCard
                            assignedCount={assignedCount}
                            badgeNumber={badgeNumber}
                            description={description}
                            image={image}
                            key={id}
                            mix={b('lesson-card')}
                            rating={rating}
                            title={subject}
                        />
                    ))}
                </Carousel.Content>
            </Carousel>
        </div>
    );
};
